import { render, staticRenderFns } from "./MenuCenters.vue?vue&type=template&id=7aa5276b"
import script from "./MenuCenters.vue?vue&type=script&lang=js"
export * from "./MenuCenters.vue?vue&type=script&lang=js"
import style0 from "./MenuCenters.vue?vue&type=style&index=0&id=7aa5276b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports